
import React, { useState, useContext, useEffect } from "react";
import LineChartD from "./dashboard-charts/ScrapLineChart";
import { getScrapData } from "./services/catalogServices";
import { AuthContext } from "../context/Auth.context";
import '../styles/dashboard.css';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import ScrapBarChart from "./dashboard-charts/ScrapBarChart";

import { EChart } from '@kbox-labs/react-echarts'
import { getDashboard } from './services/genealServises';
import Toast from './helpers/Toast';
import Spinner from './helpers/Spinner';
import { moneyFormat } from './Constants';

const Dashboard = () => {

  const [dailySales, setDailySales] = useState(0);
  const [monthlySales, setMonthlySales] = useState(0);
  const [weeklySales, setWeeklySales] = useState(0);

  const { state, CheckResponse } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [scrap, setScrap] = useState([]);
  const [scrapProducts, setScrapProducts] = useState([]);
  const [date_from, setDateFrom] = useState("");
  const [date_to, setDateTo] = useState("");
  const [total_scrap, setTotalScrap] = useState(0);
  const [total_scrap_cost, setTotalScrapCost] = useState(0);
  const [filter, setFilter] = useState(false);
  const [activeTabScrap, setActiveTabScrap] = useState('dates');

  const [barData, setBarData] = useState([]);
  const [barTitles, setBarTitles] = useState([]);

  const [lineData, setLineData] = useState([]);
  const [lineTitles, setLineTitles] = useState([]);
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      getDashboardData();
      setTimer(timer + 1);
    }, 60000);
  }, [timer]);

  const showToast = (t, d, tt) => {
    setList([...list, {
      id: Math.floor((Math.random() * 101) + 1),
      title: t,
      description: d,
      type: tt
    }]);
  }

  useEffect(() => {
    getDashboardData();
    setTimer(timer + 1);
  }, []);

  const getDashboardData = () => {
    getDashboard(state.auth).then(data => {
      CheckResponse(data);
      if (data.code == 200) {
        // console.log(data);
        setDailySales(data['daily']);
        setMonthlySales(data['monthly']);
        setWeeklySales(data['weekly']);

        setLineData(data['monthly_earns_values']);
        setLineTitles(data['monthly_earns_labels']);
        var newBarTitles = [];
        var newBardata = [];
        for (let index = 0; index < data['tops'].length; index++) {
          const element = data['tops'][index];
          newBarTitles.push(data['tops'][index].name);
          newBardata.push(data['tops'][index].qty);
        }
        setBarData(newBardata);
        setBarTitles(newBarTitles);
      } else {
        showToast('Oops!', 'Algo salio mal!', 'danger');
      }
      setLoading(false);
    }).finally(loadScrap());
  }

  const loadScrapFilter = () => {
    if (date_from && date_to) {
      setLoading(true);
      getScrapData(state.auth, date_from, date_to).then(data => {
        CheckResponse(data);
        if (data.code == 200) {
          setScrap(data.scrapData.scrapDates);
          setTotalScrap(data.scrapData.scrapTotalProducts);
          setTotalScrapCost(data.scrapData.scrapTotalCost);
          setScrapProducts(data.scrapData.scrapProducts);
        } else {
          showToast('Oops!', 'Algo salio mal!', 'danger');
        }
      })
        .finally(() => {
          setLoading(false);
          setFilter(true);
        });
    } else {
      showToast('Oops!', 'Coloca un rango de fechas', 'warning');
    }
  }

  const loadScrap = () => {
    setLoading(true);
    getScrapData(state.auth, 0, 0).then(data => {
      CheckResponse(data);
      if (data.code == 200) {
        setScrap(data.scrapData.scrapDates);
        setTotalScrap(data.scrapData.scrapTotalProducts);
        setTotalScrapCost(data.scrapData.scrapTotalCost);
        setScrapProducts(data.scrapData.scrapProducts);
      } else {
        showToast('Oops!', 'Algo salio mal!', 'danger');
      }
    })
      .finally(
        setLoading(false)
      );
  }

  const handleChangeDateFrom = (event) => {
    setDateFrom(event.target.value);
  };

  const handleChangeDateTo = (event) => {
    setDateTo(event.target.value);
  };

  const cleanDashboard = () => {
    setDateTo(0);
    setDateFrom(0);
    setFilter(false)
    loadScrap();
  }

  const makeScrapExcel = () => {
    const processedData = scrapProducts;

    if (!processedData || processedData.length === 0) {
      console.error("No data to process");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Scrap');

    const header = ["Nombre", "Cantidad", "Precio", "Total"];
    worksheet.addRow(header);

    worksheet.getRow(1).eachCell((cell, colNumber) => {
      cell.font = { bold: true, color: { argb: 'FFFFFF' } };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
    });

    processedData.forEach((row) => {
      worksheet.addRow([row.Nombre, row.Cantidad, row.Precio, row.Total]);
    });

    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = maxLength + 2;
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, `reporte de scrap ${date_from}-${date_to}.xlsx`);
    });

    setTimeout(() => {
      showToast('Hecho!', 'Reporte descargado', 'success');
      setLoading(false);
    }, 3000);
  };

  const handleTabClick = (tab) => {
    setActiveTabScrap(tab);
  };

  return (
    <>
      <Toast toastList={list} />
      <h2>Dashboard</h2>
      <div className="row">
        <div className="mt-3 col-sm-12 col-md-4">
          <span className="badge bg-primary text-wrap text-center bg-gradient" style={{ width: "100%" }}>
            <h4>Ventas Diarias</h4>
            <h5 className="mt-3">{moneyFormat.format(dailySales)}</h5>
          </span>
        </div>
        <div className="mt-3 col-sm-12 col-md-4">
          <span className="badge bg-primary text-wrap text-center bg-gradient" style={{ width: "100%" }}>
            <h4>Ventas Semanales</h4>
            <h5 className="mt-3">{moneyFormat.format(weeklySales)}</h5>
          </span>
        </div>
        <div className="mt-3 col-sm-12 col-md-4">
          <span className="badge bg-primary text-wrap text-center bg-gradient" style={{ width: "100%" }}>
            <h4>Ventas Mensuales</h4>
            <h5 className="mt-3">{moneyFormat.format(monthlySales)}</h5>
          </span>
        </div>
      </div>
      {!loading && <>
        <div>
          <div className="row mt-4">
            <div className="col-sm-12 col-md-6 mt-3 text-center">
              <h2>10 Mas Vendidos</h2>
              <EChart
                style={{
                  height: '500px',
                  width: '100%'
                }}
                xAxis={{
                  type: 'category',
                  data: barTitles,
                  axisLabel: { interval: 0, rotate: 45 }
                }}
                yAxis={{
                  type: 'value'
                }}
                series={[
                  {
                    name: 'Vendidos',
                    data: barData,
                    type: 'bar',
                    areaStyle: {},
                    // color: [
                    //   '#0d6efd',
                    // ]
                  }
                ]}
                tooltip={{
                  trigger: 'axis',
                  axisPointer: {
                    type: 'shadow'
                  },
                }}
                grid={{
                  bottom: "40%"
                }}
              />
            </div>
            <div className="col-sm-12 col-md-6 mt-3 text-center">
              <h2>Historial de Ganancias</h2>
              <EChart
                style={{
                  height: '450px',
                  width: '100%'
                }}
                xAxis={{
                  type: 'category',
                  boundaryGap: false,
                  data: lineTitles,
                  axisLabel: { interval: 0, rotate: 60 }
                }}
                yAxis={{
                  type: 'value'
                }}
                series={[
                  {
                    name: 'Ganancias',
                    data: lineData,
                    type: 'line',
                    areaStyle: {},
                    tooltip: {
                      valueFormatter: value => moneyFormat.format(value)
                    },
                    // color: [
                    //   '#0d6efd',
                    // ]
                  }
                ]}
                tooltip={{
                  trigger: 'axis',
                  axisPointer: {
                    type: 'shadow'
                  },
                }}
                grid={{
                  bottom: "25%"
                }}
              />
            </div>
          </div>

          <h2>Scrap</h2>
          <div className="row mt-2">
            <div className="col-sm-4 mt-1">
              <label>De:</label>
              <input type="date" value={date_from} onChange={(e) => handleChangeDateFrom(e)} className='form-control'></input>
            </div>
            <div className="col-sm-4 mt-1">
              <label>A:</label>
              <input type="date" value={date_to} onChange={(e) => handleChangeDateTo(e)} className='form-control'></input>
            </div>
            <div className="col-sm-4 mt-1">
              <button className="btn btn-success mt-4 m-2" onClick={() => { loadScrapFilter() }}>Aplicar filtro</button>
              {filter && <><button className="btn btn-danger mt-4 m-2" onClick={() => { cleanDashboard() }}>Quitar filtro</button></>}
            </div>
          </div>
          <div className="container">
            <div className="row row-cols-3">
              <div className="col">
                <div className="dbcard bg-c-blue order-card">
                  <div className="card-block">
                    <h6 className="m-b-20">Total de productos scrap</h6>
                    <h2 className="text-right"><i className="fa fa-refresh f-left"></i><span>{total_scrap}</span></h2>
                    <p className="m-b-0">Costo de scrap: $<span className="f-right">{total_scrap_cost}</span></p>
                  </div>
                </div>
              </div>
              <div className="col"></div>
              <div className="col"></div>
              <div className="col">
                {filter && <><button className="btn btn-primary dbbutton" onClick={() => { makeScrapExcel() }}>Descargar Excel de Scrap</button></>}
              </div>
              <div className="col"></div>
              <div className="col"></div>
            </div>
          </div>

          <div className="mt-4 mb-3">
            <h3>Productos de Scrap</h3>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTabScrap === 'dates' ? 'active' : ''}`}
                  href="#"
                  onClick={() => handleTabClick('dates')}
                >
                  Por fechas
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTabScrap === 'products' ? 'active' : ''}`}
                  href="#"
                  onClick={() => handleTabClick('products')}
                >
                  Por productos
                </a>
              </li>
            </ul>

            <div className="mt-4">
              {activeTabScrap === 'dates' && <LineChartD data={scrap} />}
              {activeTabScrap === 'products' && <ScrapBarChart data={scrapProducts} />}
            </div>
          </div>

        </div>
      </>}
      {loading && <div className="col-sm-4 mt-1">
        <Spinner size={3} margin={4}></Spinner>
      </div>}
    </>
  );

}

export default Dashboard;